export const useFormatSOCMediaUrl = (
  filename: string,
  fileExstention?: string,
) =>
  `https://www.sendoutcards.com/soc-media/images/${filename}.original.${
    fileExstention ?? 'png'
  }`
